export default {"src":"https://assets.willie.be/c0aaa858cfc53493/_next/static/media/trust.567adc75.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};